"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEnvironmentUtil = void 0;
class AppEnvironmentUtil {
    static getName() {
        return process.env.APP_ENV || 'development';
    }
    static isDevelopment() {
        return (['sandbox', 'ecomm-dev', 'ecomm-acc', 'development'].indexOf(this.getName().toLowerCase()) >= 0);
    }
    static isProduction() {
        return ['production', 'ecomm-prd'].indexOf(this.getName().toLowerCase()) >= 0;
    }
}
exports.AppEnvironmentUtil = AppEnvironmentUtil;
//# sourceMappingURL=AppEnvironmentUtil.js.map